// extracted by mini-css-extract-plugin
module.exports = {"partialWidth":"Spacer_partialWidth__2Yhq_","bounce":"Spacer_bounce__3awzm"};